import { render, staticRenderFns } from "./PrivilegeCampaignInfo.vue?vue&type=template&id=4ba156ea&scoped=true&"
import script from "./PrivilegeCampaignInfo.vue?vue&type=script&lang=js&"
export * from "./PrivilegeCampaignInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeCampaignInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PrivilegeCampaignInfo.vue?vue&type=style&index=1&id=4ba156ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba156ea",
  null
  
)

export default component.exports